module.exports = __webpack_public_path__ + "static/media/general.2f173785.md";